import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { FILTER_DATA_LIST_RESPONSE } from "../types/ResponseTypes";
import { GET_FILTER_OTS_QUERY_KEY, GET_FILTER_QUERY_KEY } from "../types/CommonTypes";

type OtsQueryParams = {
  startDate: string;
  endDate: string;
};

async function getFilterOTSData(
  params: OtsQueryParams
): Promise<FILTER_DATA_LIST_RESPONSE> {
  const { data } = await fetcher({
    url: "analytics/filter-options/ots",
    params,
  });

  return data?.options || [];
}

export function useGetFilterOTSQuery(
  params?: OtsQueryParams,
  enabled: boolean = false
) {
  return useQuery({
    queryKey: [GET_FILTER_QUERY_KEY, GET_FILTER_OTS_QUERY_KEY, params], // 🔥 cache by date range
    queryFn: () => getFilterOTSData(params as OtsQueryParams),
    enabled: enabled && !!params, 
    staleTime: 5 * 60 * 1000, 
  });
}
